<template>
  <div class="fs-content">
    <slot></slot>
    <div class="checkbox-box">
      <el-row :gutter="20" type="flex">
        <el-col :span="3" style="text-align: right;">
          <el-checkbox v-model="checked"></el-checkbox>
        </el-col>
        <el-col :span="20">
          <div class="checkbox-text">
            我已閱讀並接受以上內容。如有任何爭議，本校擁有最終決定權。
          </div>
          <div class="checkbox-text">
            I have read and accept the above content.  In case of dispute, the School reserves the right of final decision.
          </div>
        </el-col>
      </el-row>
      <el-button
        :class="{ checkedPrimary: !checked }"
        @click="onProceed"
        :disabled="!checked"
        type="primary"
      >
        <div>開始網上申請程序</div>
        <div>Proceed to Online Application</div>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    onProceed() {
      this.$emit("onProceed");
    },
  },
};
</script>

<style lang="scss" scoped>
.fs-content {
  padding: 40px;
}
.fs-title {
  font-weight: bold;
  color: #ff9300;
  font-size: 30px;
  text-align: center;
}
.welcome {
  font-weight: bold;
  font-size: 40px;
  margin-bottom: 30px;
  margin-top: 30px;
 
}

ol {
  padding: 0;
  margin: 0;
}
ol li {
  list-style-position: lower-alpha;
  margin-top: 40px;
}

.apply {
  font-size: 20px;
  font-weight: bold;
  margin-top: 50px;
}
.li-a {
  color: #000;
  font-weight: bold;
}
.checkedPrimary {
  background-color: #aaaaaa;
  border-color: #aaaaaa;
}
.checkbox-text {
  color: #0062ff;
  font-weight: bold;
  font-size: 20px;
  text-align: left;
}
.checkbox-box {
  text-align: center;
  margin-top: 40px;
}
.col-ol {
  margin-left: 50px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.col-ol li {
  margin-top: 3px;
}
::v-deep {
  a {
    color: #337ab7 !important;
    font-size: 18px;
    border-bottom: 1px solid #337ab7 !important;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
    word-wrap: break-word;
    cursor: pointer;
  }
  .el-button--primary {
    width: auto;
    margin-top: 1.875rem;
  }
  .el-button--primary.is-disabled:hover {
    background-color: #aaaaaa;
    border-color: #aaaaaa;
  }
  .el-checkbox__inner{
    width: 2rem;
    height: 2rem;
    border: 3px solid #0062ff;
    margin-top: 0.3125rem;
  }
  .el-checkbox__inner::after{
        left: 0.7375rem;
        top: 0.25rem;
        height: 0.9375rem;
    }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .fs-content {
    padding: 0.625rem;
  }
}
</style>